<template>
  <v-container
    fluid
  >
    <h1>Settings</h1>

    <template v-if="!loggedIn">
      <Login/>
      <br/>
      <div class="mt-5">
        <v-btn @click="login" :loading="loggingIn" :href="loginUrl" :disabled="!online">
          Login with Goodreads
        </v-btn>
      </div>
    </template>
    <template v-else>
      Logged in as “{{ userName }}”
      <div class="mt-5">
        <ChangePassword/>
      </div>
      <div class="mt-5">
        <v-btn @click="logout" :disabled="!online">
          Logout
        </v-btn>
      </div>
    </template>

  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ChangePassword from '../components/ChangePassword.vue'
import Login from '../components/Login.vue'

export default {
  name: 'Settings',
  components: {
    ChangePassword,
    Login
  },
  data () {
    return {
      updating: false,
      loggingIn: false
    }
  },
  computed: {
    ...mapState(['online', 'books']),
    ...mapGetters(['userName', 'loggedIn']),
    bookCount () {
      return this.books.length
    },
    loginUrl () {
      return this.$appConfig.LOGIN_URL
    }
  },
  methods: {
    login () {
      this.loggingIn = true
    },
    logout () {
      this.$store.dispatch('logout')
    },
    updateBooks () {
      this.updating = true
      this.$store.dispatch('updateBooks').then(() => {
        this.updating = false
      })
    }
  }
}
</script>
